module.exports = __webpack_public_path__ + "static/media/car.d2ea69d4.svg";